import { Check, X } from 'lucide-react'

/**
 * Compact yes/no indicator. Uses lucide icons + colour - readable in dense
 * tables without taking the space "tak/nie" text would, and consistent across
 * the app (Wymagane, Aktywne, etc.).
 */
export function BoolIcon({ value, size = 16 }: { value: boolean; size?: number }) {
  return value ? (
    <Check size={size} className="text-emerald-600" aria-label="tak" />
  ) : (
    <X size={size} className="text-slate-400" aria-label="nie" />
  )
}
